<script setup>
import { useTemplateRef } from 'vue';
import AppButton from '../../atoms/app/AppButton.vue';
import BaseModal from '../../headless/BaseModal.vue';
import AppLink from '../../atoms/app/AppLink.vue';
import AppIcon from '../../atoms/app/AppIcon.vue';

const open = defineModel('open', { type: Boolean });

const loginButtonRef = useTemplateRef('loginButtonRef');
</script>

<template>
    <BaseModal
        v-model:open="open"
        :initial-focus="loginButtonRef"
    >
        <template #headline>
            Deine Vorteile mit einem karriere.at Profil
        </template>
        <template #default>
            <ul class="mb-xl flex flex-col gap-y-xs text-left">
                <li class="flex gap-m items-center">
                    <AppIcon
                        class="text-black flex-shrink-0"
                        name="check"
                    />
                    Übersicht über abgeschickte Bewerbungen
                </li>
                <li class="flex gap-m items-center">
                    <AppIcon
                        class="text-black flex-shrink-0"
                        name="check"
                    />
                    Die nächste Bewerbung geht schneller
                </li>
                <li class="flex gap-m items-center">
                    <AppIcon
                        class="text-black flex-shrink-0"
                        name="check"
                    />
                    Werde entdeckt und erhalte Jobangebote
                </li>
            </ul>
        </template>
        <template #actions>
            <div class="inline-flex flex-col gap-s">
                <AppButton
                    ref="loginButtonRef"
                    :to="{ name: 'login' }"
                >
                    Jetzt anmelden
                </AppButton>
                <div>
                    Neu hier?
                    <AppLink :to="{ name: 'register' }">
                        Kostenlos registrieren
                    </AppLink>
                </div>
            </div>
        </template>
    </BaseModal>
</template>
